var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 10H42.5C42.776 10 43 10.224 43 10.5V23.5C43 23.776 42.776 24 42.5 24H39.5C39.224 24 39 23.776 39 23.5V10.5C39 10.224 39.224 10 39.5 10Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 12H39V23.5C39 23.776 38.776 24 38.5 24H35.5C35.224 24 35 23.776 35 23.5V12.5C35 12.224 35.224 12 35.5 12Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25H10V24C10 23.448 10.448 23 11 23H25C25.552 23 26 23.448 26 24V25Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 26H4V24.5C4 24.224 4.224 24 4.5 24H43.5C43.776 24 44 24.224 44 24.5V26Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26H44V43C44 43.552 43.552 44 43 44H31C30.448 44 30 43.552 30 43V26Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H6V43.5C6 43.776 5.776 44 5.5 44H4.5C4.224 44 4 43.776 4 43.5V26Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7H28C28.552 7 29 7.448 29 8V20C29 20.552 28.552 21 28 21H8C7.448 21 7 20.552 7 20V8C7 7.448 7.448 7 8 7Z",
    fill: "url(#paint6_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H15V23H21V21Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41C37.5523 41 38 40.5523 38 40C38 39.4477 37.5523 39 37 39C36.4477 39 36 39.4477 36 40C36 40.5523 36.4477 41 37 41Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34C37.5523 34 38 33.5523 38 33C38 32.4477 37.5523 32 37 32C36.4477 32 36 32.4477 36 33C36 33.5523 36.4477 34 37 34Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23C41.5523 23 42 22.5523 42 22C42 21.4477 41.5523 21 41 21C40.4477 21 40 21.4477 40 22C40 22.5523 40.4477 23 41 23Z",
    fill: "#323538"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37 23C37.5523 23 38 22.5523 38 22C38 21.4477 37.5523 21 37 21C36.4477 21 36 21.4477 36 22C36 22.5523 36.4477 23 37 23Z",
    fill: "#323538"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26H6V32H30V26Z",
    fill: "url(#paint8_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.466,
    y1: 10.622,
    x2: 41.563,
    y2: 23.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 36.561,
    y1: 12.515,
    x2: 37.504,
    y2: 23.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16538C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 13.553,
    y1: 28.02,
    x2: 22.048,
    y2: 20.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 24,
    y1: 24.127,
    x2: 24,
    y2: 26.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#E9A144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#E28D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 37,
    y1: 43.978,
    x2: 37,
    y2: 25.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#D97218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#C46716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA6215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 5,
    y1: 43.978,
    x2: 5,
    y2: 25.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#D97218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#C46716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA6215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9365 36.1343) scale(39.234 36.3551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#23D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#23D4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#21C7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#1FB0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#1C91EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1969F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#1860FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 18,
    y1: 23.004,
    x2: 18,
    y2: 20.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#565B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#626A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#6B757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#717B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#727D86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 18,
    y1: 43.946,
    x2: 18,
    y2: 25.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#B35E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#A65613"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.2b2f24e3c146f36005b14eefb1b644fb.svg";
export { ForwardRef as ReactComponent };